define.alias("shared/components/shared/carousel/inner", "media/components/shared/carousel/inner");